import { FC, useEffect, useMemo, useState } from 'react';
import { request } from 'src/common/request';
import { SelectSpacePage } from 'src/views/oauth/select-space-page';
import { BlockDTO, BotDTO, IntegrationItem } from '@next-space/fe-api-idl';
import { useTocIds } from '../../aside/toc/use-toc-id';
import { useCurrentUser } from 'src/hooks/user';
import { LoadingIcon } from 'src/common/components/loading-icon';
import { cache, dispatch } from 'src/redux/store';
import { segmentsToText } from 'src/editor/utils/editor';
import { NextBlock } from 'src/redux/types';
import { blocksActions } from 'src/redux/reducers/blocks';

interface Props {
  bot: BotDTO;
  integration: IntegrationItem;
  onCloseModal: () => void;
}
export const SelectPageSetting: FC<Props> = (props) => {
  const [pageIds, setPageIds] = useState<string[]>([]);
  const currentUser = useCurrentUser();
  const tocIds = useTocIds(props.bot?.spaceId ?? '', currentUser.uuid, false);
  const [loading, setLoading] = useState(true);
  const teamPages = useMemo(
    () =>
      tocIds.team
        .filter((v) => pageIds.find((pageid) => pageid === v))
        .reduce((acc, v) => {
          acc[v] = true;
          return acc;
        }, {} as Record<string, boolean>),
    [tocIds.team, pageIds]
  );
  const personPages = useMemo(
    () =>
      tocIds.person
        .filter((v) => pageIds.find((pageid) => pageid === v))
        .reduce((acc, v) => {
          acc[v] = true;
          return acc;
        }, {} as Record<string, boolean>),
    [tocIds.person, pageIds]
  );

  // 计算手动选择的页面（不在team和person目录中的页面）
  const manualPages = useMemo(() => {
    const allTocIds = [...tocIds.team, ...tocIds.person];
    const manualPageIds = pageIds.filter((pageId) => !allTocIds.includes(pageId));

    return manualPageIds.reduce((acc, pageId) => {
      const block = cache.blocks[pageId];
      if (block) {
        acc[pageId] = {
          id: pageId,
          title: segmentsToText(block.data.segments) || 'Untitled',
          icon: block.data.icon,
          type: block.type,
          data: block.data,
        };
      }
      return acc;
    }, {} as Record<string, any>);
  }, [pageIds, tocIds.team, tocIds.person]);

  useEffect(() => {
    void request.integration
      .getBotPages(props.bot.uuid)
      .then((res) => {
        const noExistBlock = res.pages
          ?.filter((v) => {
            return !cache.blocks[v.uuid];
          })
          ?.reduce((pre, current) => {
            pre[current.uuid] = current;
            return pre;
          }, {} as Record<string, BlockDTO>);
        dispatch(blocksActions.update({ blocks: noExistBlock as Record<string, NextBlock> }));
        setPageIds(res.pages?.map((v) => v.uuid) ?? []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center max-w-[600px] w-[50vw] px-4 pb-2 h-[60vh] ">
        <LoadingIcon />
      </div>
    );
  }
  return (
    <div className="max-w-[600px] w-[50vw] px-4 pb-2">
      <SelectSpacePage
        integration={props.integration}
        scope={'all'}
        redirectUri={''}
        state={''}
        onBack={() => {
          props.onCloseModal();
        }}
        onUpdate={() => {
          props.onCloseModal();
        }}
        bot={props.bot}
        selectedTeamPages={teamPages}
        selectedPersonPages={personPages}
        selectedManualPages={manualPages}
      />
    </div>
  );
};
